import { AccordionOpen, BrowseNewProducts } from '@analytics/store';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@core/components/base/base.component';
import { fadeInOut } from '@dgx-pr-spa/shared/util';
import { AccordionPanel } from '@domgen/dgx-fe-components/accordion';
import { Store } from '@ngrx/store';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { map, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  animations: [fadeInOut],
})
export class LandingComponent extends BaseComponent implements OnInit {
  panels: AccordionPanel[] = [];

  offersState$ = this.viewOffersService.offersState$;

  constructor(
    private router: Router,
    public readonly viewOffersService: ViewOffersService,
    private store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.panels = [
      {
        title: "1. See what's on offer",
        body: '',
      },
      {
        title: '2. Make sure it will fit',
        body: '',
      },
      {
        title: '3. Book delivery and installation',
        body: '',
      },
      {
        title: '4. Replace your protection plan',
        body: '',
      },
    ];
  }

  goToOffers() {
    this.store.dispatch(
      BrowseNewProducts({
        label: 'Browse new products',
      })
    );

    this.offersState$
      .pipe(
        takeUntil(this.destroy$),
        map((state) => state.data),
        take(1)
      )
      .subscribe((offers) => {
        const singleOption = offers.replacement_offers?.length === 1;
        if (singleOption) {
          this.viewOffersService.selectOffer(offers.replacement_offers[0]);
        } else {
          this.router.navigate(['/offers'], {
            queryParamsHandling: 'preserve',
          });
        }
      });
  }

  trackEvent(panelToggle: {
    panel: AccordionPanel;
    isExpanded: boolean;
  }): void {
    if (!panelToggle.isExpanded) return;

    this.store.dispatch(
      AccordionOpen({
        title: panelToggle.panel.title,
      })
    );
  }
}
